<script lang="ts" setup>
import type { SupportArticle, SupportCategory } from '@consumer/types/SupportArticle'
import ContactUsCard from '@consumer/modules/support/ContactUsCard.vue'
import LookupOrderNumberForm from '@consumer/modules/support/LookupOrderNumberForm.vue'
import LookupGiftCodeForm from '@consumer/modules/support/LookupGiftCodeForm.vue'
import OrderHeader from '@consumer/modules/support/OrderHeader.vue'
import type { PurchasedOrder } from '@consumer/types/serializers'
import type { BuyerOrRecipientGift } from './support'
import { articleUrl } from './support'

defineProps<{
  currentCategory: SupportCategory
  currentArticle: SupportArticle
  gift?: BuyerOrRecipientGift
  order?: PurchasedOrder
}>()

const goBack = () => {
  window.history.back()
}
</script>

<template>
  <GCard rounded shadow class="paragraphs !p-6 !lg:p-8">
    <a class="link font-semibold" @click="goBack">Go Back</a>
    <OrderHeader
      v-if="gift || order"
      :gift="gift"
      :order="order"
      :currentCategory="currentCategory"
      class="mt-4"
    />

    <h1 class="text-lg lg:text-2xl mt-4 mb-6">{{ currentArticle.question }}</h1>

    <Markdown :content="currentArticle.answer"/>

    <LookupOrderNumberForm v-if="currentArticle.key === 'have_the_order_number'"/>
    <LookupGiftCodeForm v-if="currentArticle.key === 'have_the_activation_code'"/>

    <div v-if="currentArticle.relatedArticles" class="mt-10 space-y-2">
      <div class="font-semibold pb-2">Related Articles</div>
      <div v-for="relatedArticle, i in currentArticle.relatedArticles" :key="i">
        <GLink
          :href="articleUrl(relatedArticle, { gift, order })"
          class="font-semibold link"
        >
          {{ relatedArticle.question }}
        </GLink>
      </div>
    </div>
  </GCard>

  <ContactUsCard/>
</template>
